import './bootstrap';
import Vue from 'vue';
import './event-bus';
import VueRouter from 'vue-router';
import SearchComponent from "./components/SearchComponent.vue";
import BuyingComponent from "./components/BuyingComponent.vue";
import CatalogComponent from "./components/CatalogComponent";
import NameModalComponent from "./components/NameModalComponent";
import CatalogLoaderComponent from "./components/CatalogLoaderComponent";
import PrototypeCardComponent from "./components/PrototypeCardComponent";
import PrototypeFavoriteComponent from "./components/PrototypeFavoriteComponent";
import NumberCounterComponent from "./components/NumberCounterComponent";
import IsFavoriteComponent from "./components/IsFavoriteComponent";
import GuideComponent from "./components/GuideComponent";
import CatalogSearchComponent from "./components/CatalogSearchComponent";
import CollectiveJoin from "./components/CollectiveJoin";
import uuid from '@estudioliver/vue-uuid-v4';
import vueBemCn from 'vue-bem-cn';
import Cookies from 'universal-cookie';
import BuyingShowComponent from "./components/crm/BuyingShowComponent";
import HistoryEntityComponent from "./components/crm/HistoryEntityComponent";
import UserShowComponent from "./components/crm/UserShowComponent";
import DocumentTableComponent from "./components/crm/DocumentTableComponent";
import FeedbacksComponent from "./components/FeedbacksComponent";
import RequestComponent from "./components/RequestComponent";
import RequestItemsComponent from "./components/RequestItemsComponent";
import UnloadingComponent from "./components/UnloadingComponent";
import FeedbackModalComponent from "./components/FeedbackModalComponent";
import {default as Vuedals} from 'vuedals';
import store from "./store";
import VueSocketIO from 'vue-socket.io';
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import SellerParticipationFilter from "./components/SellerParticipationFilter";
import BuyingFilter from "./components/BuyingFilter";
import DynamicLink from "./components/DynamicLink";
import SellerBuyingComponent from "./components/SellerBuyingComponent";


// import Tree from 'vuejs-tree';


// import Tree from 'vuejs-tree';


// import Tree from 'vuejs-tree';

// Заглушка для прообраза товара если нет ни однолй картинки у подгруппы
Vue.prototype.$LOGO_CAT_NO_FOUND = '/images/logo_category_no_found.png';

// TinyMce Key
Vue.prototype.$TINY_MCE_KEY = 'ustc9mk403jkpg34xboejymnn7niyl6ub3b5km1llw94t9fg';

Vue.use(ElementUI);
Vue.use(Vuedals);
Vue.use(vueBemCn, {
    delimiters: {
        ns: '',
        el: '__',
        mod: '_',
        modVal: '_',
    }
});
Vue.use(VueRouter);

Vue.use(uuid);

import wsConfig from "../../../ws/config.js";

Vue.use(new VueSocketIO({
    debug: true,
    connection: wsConfig.wsHost + ':' + wsConfig.wsPort,
    vuex: {
        store,
        actionPrefix: 'SOCKET_',
        mutationPrefix: 'SOCKET_'
    }
}));

const router = new VueRouter({
    mode: 'history'
});
Vue.component(SearchComponent.name, SearchComponent);
Vue.component(BuyingComponent.name, BuyingComponent);
Vue.component(CatalogComponent.name, CatalogComponent);
Vue.component(NameModalComponent.name, NameModalComponent);
Vue.component(CatalogLoaderComponent.name, CatalogLoaderComponent);
Vue.component(PrototypeCardComponent.name, PrototypeCardComponent);
Vue.component(PrototypeFavoriteComponent.name, PrototypeFavoriteComponent);
Vue.component(NumberCounterComponent.name, NumberCounterComponent);
Vue.component(IsFavoriteComponent.name, IsFavoriteComponent);
Vue.component(GuideComponent.name, GuideComponent);
Vue.component(CatalogSearchComponent.name, CatalogSearchComponent);
Vue.component(SellerParticipationFilter.name, SellerParticipationFilter);
Vue.component(BuyingFilter.name, BuyingFilter);
Vue.component(DynamicLink.name, DynamicLink);
Vue.component(CollectiveJoin.name, CollectiveJoin);
Vue.component(BuyingShowComponent.name, BuyingShowComponent);
Vue.component(HistoryEntityComponent.name, HistoryEntityComponent);
Vue.component(UserShowComponent.name, UserShowComponent);
Vue.component(DocumentTableComponent.name, DocumentTableComponent);
Vue.component(FeedbacksComponent.name, FeedbacksComponent);
Vue.component(RequestComponent.name, RequestComponent);
Vue.component(RequestItemsComponent.name, RequestItemsComponent);
Vue.component(UnloadingComponent.name, UnloadingComponent);
Vue.component(FeedbackModalComponent.name, FeedbackModalComponent);
Vue.component(SellerBuyingComponent.name, SellerBuyingComponent);
// Vue.component(Tree.name, Tree);

// Добавляем логику для некоторых функций
// unique - ищет в цикле уникальные значения
Vue.mixin({
    computed: {
        unique () {
            return function (arr, key) {
                var output = [];
                var usedKeys = {};
                for (var i = 0; i < arr.length; i++) {
                    if (!usedKeys[arr[i][key]]) {
                        usedKeys[arr[i][key]] = true;
                        output.push(arr[i]);
                    }
                }
                return output;
            }
        }
    }
});

const app = new Vue({
    cookies: new Cookies(),
    router,
    store,
    el: '#app',
    data() {
        return {
            showMatch: true
        }
    },
    methods: {
        privateBuying: function () {
            this.showMatch = !this.showMatch;
        }
    }

});
